// [INFLOWS] Type column is OPTIONAL — a real FLOW-constituent row can omit
// it entirely (the real engine sets type=FLOW unconditionally for those; the
// Type-column parsing only exists for a POLLUTANT row's CONCEN/MASS
// choice). Defaulting a missing column to "CONCEN" unconditionally would
// silently mis-type an omitted-Type FLOW row, which a downstream `type !==
// "FLOW"` check then drops outright with no warning. The default below
// must mirror the constituent instead.

import { parseNum } from "./parseNum.ts";
import { writeOrDeleteSection } from "./writeOrDeleteSection.ts";

export type InflowType = "FLOW" | "CONCEN" | "MASS";

export interface ExternalInflow {
  node: string;
  constituent: string;
  timeSeries: string;
  type: InflowType;
  unitsFactor: number;
  scaleFactor: number;
  baseline: number;
  basePattern: string;
}

export function readInflows(
  raw: ReadonlyMap<string, string[][]>,
  warnings?: Set<string>
): ExternalInflow[] {
  return (raw.get("INFLOWS") ?? [])
    .filter((row) => row[0] && row[1])
    .map((row) => {
      const ctx = (field: string) => `[INFLOWS] "${row[0]}" ${row[1]} ${field}`;
      return {
        node: row[0],
        constituent: row[1],
        timeSeries: row[2] ?? "",
        type:
          (row[3]?.toUpperCase() as InflowType | undefined) ??
          (row[1].toUpperCase() === "FLOW" ? "FLOW" : "CONCEN"),
        unitsFactor: parseNum(row[4], 1, ctx("Units Factor"), warnings),
        scaleFactor: parseNum(row[5], 1, ctx("Scale Factor"), warnings),
        baseline: parseNum(row[6], 0, ctx("Baseline"), warnings),
        basePattern: row[7] ?? "",
      };
    });
}

export function writeInflows(
  raw: ReadonlyMap<string, string[][]>,
  inflows: ExternalInflow[]
): Map<string, string[][]> {
  const rows = inflows.map((i) => [
    i.node,
    i.constituent,
    i.timeSeries,
    i.type,
    String(i.unitsFactor),
    String(i.scaleFactor),
    String(i.baseline),
    i.basePattern,
  ]);
  return writeOrDeleteSection(raw, "INFLOWS", rows);
}
